interface Props {
  dataUrl: string;
  alt?: string;
}

// The cerberus mfa_enroll handler returns a pre-rendered PNG data URL.
// We just embed it — no client-side QR generation needed.
export default function QrCode({ dataUrl, alt = "TOTP QR code" }: Props): JSX.Element {
  return (
    <img
      src={dataUrl}
      alt={alt}
      style={{
        width: 200,
        height: 200,
        background: "white",
        padding: 8,
        borderRadius: 6,
      }}
    />
  );
}
